var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27 1.86C6.73 0.62 7.61 0 8.91 0C9.79 0 10.51 0.26 11.07 0.780001C11.63 1.28 11.91 2.03 11.91 3.03V22.7976C11.91 23.7263 11.4799 24.6026 10.7452 25.1707C9.66448 26.0065 8.15552 26.0065 7.07476 25.1707C6.34011 24.6026 5.91 23.7263 5.91 22.7976V9.3H3.09C2.25 9.3 1.52 9.09 0.9 8.67C0.3 8.25 0 7.62 0 6.78C0 6.08 0.21 5.52 0.63 5.1C1.05 4.68 1.56 4.43 2.16 4.35C3.12 4.23 3.97 3.99 4.71 3.63C5.47 3.25 5.99 2.66 6.27 1.86Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.99c0c9fd559d81c3c358db7d861269b6.svg";
export { ForwardRef as ReactComponent };